import LinkRootBlocks from "../../../components/blocks/LinkRootBlocks"
import ROUTES from "../../../routes/Routes"

export default function LinkrootServer() {
    return (
        <>
            <LinkRootBlocks
                maintitle="¿Qué opción deseas revisar?"
                columnsPerRow={3}
                blocks={[
                    { ico: "bi bi-info-circle-fill", title: "Logs", link: ROUTES.LOGS_VIEWER}             
                ]}
            />
        </>
    )
}